export const VALIDATION_MESSAGE = {
  get: function (title: string, validator: string, min?: number, max?: number) {
    switch (validator) {
      case "required":
        return `${title} is required.`;
      case "uuid":
        return `Invalid ${title} uuid format`;
      case "empty":
        return `${title} uuid format`;
      case "number":
        return `${title} must be a number`;
      case "boolean":
        return `${title} must be true or false`;
      case "min_max":
        return `${title} must be between ${min}, ${max} character`;
      case "max":
        return `${title} must not exceed ${max} character`;
      case "exact":
        return `${title} must be exact ${min} character`;
      case "array":
        return `${title} must be an array`;
      case "positive":
        return `${title} must contain only positive numbers`;
      case "max_number":
        return `${title} must be less than or equal to ${min}`;
      case "min_number":
        return `${title} must be greater than or equal to ${min}`;
      case "lesser_than":
        return `${title} must be less than ${min}`;
      case "greater_than":
        return `${title} must be greater than ${min}`;
      default:
        return `${title} is invalid`;
    }
  },
};

export const GLOBAL_ERROR_MESSAGE = "An error occurred";

export const FORGOT_PASSWORD_MESSAGES = {
  SUCCESS:
    "If an account with that email address exists, we have sent you a password reset link.",
  EMAIL_REQUIRED: "Email is required",
  INVALID_EMAIL: "Please enter a valid email address",
  EMAIL_TOO_LONG: "Email must be less than 255 characters",
  NETWORK_ERROR:
    "Connection error. Please check your internet connection and try again.",
  RATE_LIMITED: "Too many reset requests. Please wait before trying again.",
};

export const RESET_PASSWORD_MESSAGES = {
  SUCCESS: "Your password has been reset successfully.",
  PASSWORD_REQUIRED: "Password is required",
  PASSWORD_TOO_SHORT: "Password must be at least 8 characters",
  PASSWORD_NO_UPPERCASE: "Password must include an uppercase letter",
  PASSWORD_NO_LOWERCASE: "Password must include a lowercase letter",
  PASSWORD_NO_NUMBER: "Password must include a number",
  PASSWORD_TOO_LONG: "Password must be less than 50 characters",
  CONFIRM_PASSWORD_REQUIRED: "Please confirm your password",
  PASSWORDS_DONT_MATCH: "Passwords do not match. Please try again",
  TOKEN_REQUIRED: "Reset token is required",
  INVALID_TOKEN: "Invalid or expired reset link. Please request a new one",
  EMAIL_REQUIRED: "Email is required",
  INVALID_EMAIL: "Please enter a valid email address",
  EMAIL_TOO_LONG: "Email must be less than 255 characters",
  NETWORK_ERROR:
    "Connection error. Please check your internet connection and try again.",
  LOGIN_FAILED:
    "Password reset successful but login failed. Please login manually.",
};

export const REGISTER_MESSAGES = {
  SUCCESS: "Account created successfully! Welcome to our platform.",
  FIRST_NAME_REQUIRED: "First name is required",
  FIRST_NAME_INVALID: "First name can only contain letters and spaces",
  LAST_NAME_REQUIRED: "Last name is required",
  LAST_NAME_INVALID: "Last name can only contain letters and spaces",
  EMAIL_REQUIRED: "Email is required",
  INVALID_EMAIL: "Please enter a valid email address",
  EMAIL_EXISTS: "An account with this email already exists",
  PASSWORD_REQUIRED: "Password is required",
  PASSWORD_TOO_SHORT: "Password must be at least 8 characters",
  PASSWORD_WEAK:
    "Password must contain at least one uppercase letter, one lowercase letter, and one number",
  USER_TYPE_REQUIRED: "Please select a user type",
  NETWORK_ERROR:
    "Connection error. Please check your internet connection and try again.",
  SERVER_ERROR: "Something went wrong. Please try again later.",
  TOKEN_ERROR: "Authentication failed. Please try again.",
};
